import { render, staticRenderFns } from "./DetailLessonList.vue?vue&type=template&id=066ef0bc&scoped=true&"
import script from "./DetailLessonList.vue?vue&type=script&lang=js&"
export * from "./DetailLessonList.vue?vue&type=script&lang=js&"
import style0 from "./DetailLessonList.vue?vue&type=style&index=0&id=066ef0bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066ef0bc",
  null
  
)

export default component.exports